import { useEffect } from 'react';

interface TidioChatApi {
    hide: () => void;
    show: () => void;
}

declare global {
    interface Window {
        tidioChatApi?: TidioChatApi;
    }
}

export function useHideTidio() {
    useEffect(() => {
        let mounted = true;
        const hide = () => {
            if (mounted) window.tidioChatApi?.hide();
        };
        hide();
        document.addEventListener('tidioChat-ready', hide);
        return () => {
            mounted = false;
            document.removeEventListener('tidioChat-ready', hide);
            window.tidioChatApi?.show();
        };
    }, []);
}
